/**
 * @file The component to generate reference pictures
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';
import 'antd/dist/antd.css';
import { pic2StateMap } from '../../Utils/WindowsDataLoader';
import Zmage from 'react-zmage';
import classes from './ReferencePicture.module.css';
import { getPageObjectByName } from '../../Utils/PageObjectsMapUtil';
import {
    M2021,
    M11_3_4,
    M11_3_4_1,
    M11_3_5,
    M11_3_5_1,
    M11_3_5_2,
    M11_3_6,
    M11_3_7,
    M11_3_8,
    M11_3_9,
    M11_3_10,
    M11_3_11,
    M11_3_12,
    M11_4_03,
    M11_4_06,
    M11_4_09,
    M11_4_12
} from '../../Utils/Constants';

const referencePicture = (props) => {
    /**
     * Generate a picture display list whose index are paralleling to the steps.
     * The pictures added to the list is based on the features selected
     * @param {Object} pageObjects object that contains information for each page
     * @return {Array} return a list that contains pictures to display in order
     */
    const generatePics = (pageName, useVersion) => {
        //Special case to dynamically load remote repository refer pic
        if (
            pageName === 'linRemoteRepository' ||
            pageName === 'winRemoteRepository'
        ) {
            return getRemoteRepoPic(pageName, useVersion);
        }

        let pageObject = getPageObjectByName(pageName);
        if (typeof pageObject !== 'undefined') {
            return pageObject['referPic'];
        }
        return null;
    };

    /**
     * Handle the special case for remote repository page. Need to dynamically change the refer pic
     * based on the selection of PA and Collaboration
     * @param {Object} pageObjects object that contains information for each page
     * @return {Array} return a list that contains pictures to display in order
     */
    const getRemoteRepoPic = (pageName, useVersion) => {
        let rebranded;
        const versions = [M2021, M11_3_4, M11_3_4_1, M11_3_5, M11_3_5_1, M11_3_5_2, M11_3_6, M11_3_7, M11_3_8, M11_3_9, M11_3_10, M11_3_11, M11_3_12, M11_4_03, M11_4_06, M11_4_09, M11_4_12];
        if (versions.includes(useVersion)) {
            rebranded = false;
        } else {
            rebranded = true;
        }
        
        if (pageName === 'winRemoteRepository') {
            // show refer page has PA words only
            if (
                props.getOriginState('platformAnalyticsSelect') &&
                !props.getOriginState('collaborationSelect')
            ) {
                if (rebranded) {
                    return ['assets/ReferencePics/Windows/Remote Repository PA Rebranded.png'];
                }
                return [
                    'assets/ReferencePics/Windows/Remote Repository PA.png',
                ];
            }
            // show refer page has Collab words only
            if (
                props.getOriginState('collaborationSelect') &&
                !props.getOriginState('platformAnalyticsSelect')
            ) {
                if (rebranded) {
                    return ['assets/ReferencePics/Windows/Remote Repository Collab Rebranded.png'];
                }
                return [
                    'assets/ReferencePics/Windows/Remote Repository Collab.png',
                ];
            }

            if (rebranded) {
                return ['assets/ReferencePics/Windows/Remote Repository Rebranded.png'];
            }
            return ['assets/ReferencePics/Windows/Remote Repository.png'];
        } else if (pageName === 'linRemoteRepository') {
            if (
                props.getOriginState('platformAnalyticsActive') &&
                !props.getOriginState('collaborationActive')
            ) {
                if (rebranded) {
                    return ['assets/ReferencePics/Linux/Remote Repository PA Rebranded.png'];
                }
                return ['assets/ReferencePics/Linux/Remote Repository PA.png'];
            }

            if (
                props.getOriginState('collaborationActive') &&
                !props.getOriginState('platformAnalyticsActive')
            ) {
                if (rebranded) {
                    return ['assets/ReferencePics/Linux/Remote Repository Collab Rebranded.png'];
                }
                return [
                    'assets/ReferencePics/Linux/Remote Repository Collab.png',
                ];
            }

            if (rebranded) {
                return ['assets/ReferencePics/Linux/Remote Repository Rebranded.png'];
            }
            return ['assets/ReferencePics/Linux/Remote Repository.png'];
        }

        return null;
    };

    let pictures = generatePics(props.pageName, props.useVersion);

    return pictures.map((item, index) => {
        // special cases for wev&mobileVDS and portal&mdxVDS pages in Windows Installation
        let picState = pic2StateMap.get(item);
        if (typeof picState !== 'undefined') {
            if (!props.getOriginState(picState)) {
                return null;
            }
        }
        let picture = require('../../' + item);

        return (
            <Zmage
                className={classes.img}
                src={picture}
                style={
                    index === 0
                        ? { width: '100%', height: 'auto' }
                        : { width: '100%', height: 'auto', marginTop: '32px' }
                }
                backdrop="rgba(0, 0, 0, 0)"
                controller={{
                    close: true,
                    zoom: false,
                    download: false,
                    rotate: false,
                    flip: false,
                    pagination: false,
                }}
                key={item.toString() + index.toString()}
            />
        );
    });
};

export default referencePicture;
